__turbopack_context__.v({
  "content": "ks6JaG_content",
  "root": "ks6JaG_root",
  "subtitle": "ks6JaG_subtitle",
  "title": "ks6JaG_title",
});
